import React, { useState } from "react";
import firebase from "firebase/app";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  DialogActions,
  DialogContentText,
  Button,
  CircularProgress,
} from "@material-ui/core";
import { setErrorDetails } from "../../../api/userSlice";
import { useDispatch } from "react-redux";

export default function ChangeEmailDialog(props) {
  const { handleClose, open } = props;

  const [oldPassword, setOldPassword] = useState("");
  const [newEmail, setNewEmail] = useState("");
  const currentEmail = firebase.auth().currentUser.email;
  const dispatch = useDispatch();
  const [isUpdating, setIsUpdating] = useState(false);

  const handleUpdateEmail = async () => {
    setIsUpdating(true);

    try {
      await firebase
        .auth()
        .signInWithEmailAndPassword(currentEmail, oldPassword);
      await firebase.auth().currentUser.updateEmail(newEmail);

      dispatch(
        setErrorDetails({
          message: null,
        })
      );
      handleClose();
    } catch (error) {
      dispatch(
        setErrorDetails({
          message: error.message,
        })
      );
    } finally {
      setIsUpdating(false);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="form-dialog-title"
    >
      <DialogTitle id="form-dialog-title">Edit Email</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Fill in these fields to update your email:
        </DialogContentText>
        <TextField
          disabled
          margin="dense"
          label="Email address"
          fullWidth
          value={currentEmail}
        />
        <TextField
          margin="dense"
          label="New email address"
          fullWidth
          onChange={(event) => setNewEmail(event.target.value)}
        />
        <TextField
          type="password"
          margin="dense"
          label="Password"
          fullWidth
          onChange={(event) => setOldPassword(event.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="white">
          Cancel
        </Button>
        <Button
          disabled={oldPassword.length < 3 || newEmail.length < 3}
          onClick={handleUpdateEmail}
          color="primary"
        >
          {isUpdating ? <CircularProgress size={10} /> : "Update"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
